module.exports = __webpack_public_path__ + "assets/storemanagement.ad4a6e4a.svg";